<template>
  <div>
    <advice v-for="advice in advices" :key="advice.id" :id="advice.id"></advice>
    <div class="w-full border rounded h-28 flex justify-center items-center cursor-pointer" @click="openCreation = true">
      <font-awesome-icon icon="plus"></font-awesome-icon>
    </div>

    <advice-form v-if="openCreation" :alias="event" :type="constantType" :open="openCreation" @close="close"></advice-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import advice from '@/components/advice/advice.vue'
import adviceForm from '@/components/advice/advice-form.vue'

export default {
  name: 'advice-list',

  components: { advice, adviceForm },

  props: {
    type: {
      type: String,
      required: true
    },
    event: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      openCreation: false
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),

    ...mapGetters('advices', {
      listing: 'advices'
    }),

    advices () {
      return this.listing.filter((advice) => {
        return advice.event === this.event && advice.type === this.constantType
      })
    },

    constantType () {
      let type = null
      switch (this.type) {
      case 'upw':
        type = 'userPreviousWeek'
        break
      case 'uat':
        type = 'userAllOverTheTime'
        break
      case 'gcw':
        type = 'globalCurrentWeek'
        break
      case 'gat':
        type = 'globalAllowerTheTime'
        break
      }
      return type
    }
  },

  methods: {
    close () {
      this.openCreation = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/advice/advice-list.vue